// extracted by mini-css-extract-plugin
export default {"container":"AL-z","dimension":"BL-z","dimensionLabels":"CL-z"};